import { z } from 'zod';

export const GroupsSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  permissions: z.array(
    z.object({
      id: z.number(),
      label: z.string(),
    }),
  ),
});

export type GroupsSchemaType = z.infer<typeof GroupsSchema>;
